import styled from "styled-components"
import media from "styled-media-query"

import Img from "gatsby-image"

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.lessThan("medium")`
    padding: 35px 20px;
  `}

  ${media.greaterThan("medium")`
    padding: 35px 120px;
  `}

  ${media.greaterThan("large")`
    padding: 35px 170px;
  `}
`

export const Title = styled.h1`
  font-weight: 600;
  line-height: 1.5;
  color: var(--titleColor);

  ${media.lessThan("medium")`
    font-size: 1.5rem;
    text-align: center;
  `}

  ${media.greaterThan("medium")`
    font-size: 1.85rem;
    text-align: start;
  `}

  ${media.greaterThan("large")`
    font-size: 2rem;
    text-align: start;
  `}
`

export const Subtitle = styled.p`
  font-weight: 400;
  line-height: 1.3;
  margin: 15px 0;
  color: var(--texts);

  ${media.lessThan("medium")`
    font-size: 1.05rem;
  `}

  ${media.greaterThan("medium")`
    font-size: 1.3rem;
  `}

  ${media.greaterThan("large")`
    font-size: 1.5rem;
  `}
`

export const LinkToHome = styled.a`
  color: var(--highlight);
  cursor: pointer;
`

export const ContainerHero = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 20px 0 30px 0;
  height: auto;

  ${media.lessThan("medium")`
    padding: 10px;
  `}

  ${media.greaterThan("large")`
    margin: 30px 0 40px 0;
  `}
`

export const Hero404 = styled(Img)`
  height: auto;

  ${media.lessThan("medium")`
    width: 100%;
  `}

  ${media.greaterThan("medium")`
    width: 80%;
  `}

  ${media.greaterThan("large")`
    width: 60%;
  `}
`
